<template>
  <div class="m-card" ref="container">
    <div class="m-card_header">
      <div class="m-card_header-content" :style="headerContentStyle">
        <slot name="header">
          <MIcon class="m-card_header-icon" v-if="icon" v-bind="icon" />
          <span class="m-card_header-title">{{ title }}</span>
        </slot>
      </div>
      <div class="m-card_header-bg">
        <div class="pos-right">
          <i class="parallelogram"></i>
          <i class="parallelogram"></i>
          <i class="parallelogram"></i>
          <i class="parallelogram"></i>
          <i class="parallelogram"></i>
        </div>
      </div>
    </div>
    <div
      class="m-card_content"
      ref="content"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
      element-loading-text="Loading"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import MIcon from '@/components/mIcon/index.vue';

export default {
  components: { MIcon },
  props: {
    title: String,
    icon: {
      type: [Object, null],
      default: null
    },
    titleAlign: {
      type: String,
      default: 'left'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerContentStyle() {
      const dict = {
        left: 'flex-start',
        right: 'flex-end',
        center: 'center'
      };

      return {
        justifyContent: dict[this.titleAlign]
      };
    }
  }
};
</script>

<style lang="scss">
.m-card {
  --lt-mark-size: 15px;
  --lt-mark-color: var(--mcard-header-mark-color);

  --rt-mark-width: 160px;
  --rt-mark-bar: 14px;
  --rt-mark-gap: 8px;

  // --mcard-header-height: 60px;
  // --mcard-header-fs: 35px;
  // --mcard-header-bg: #1c354d;
  // --mcard-border: 2px solid #2d80b0;
  // --mcard-bg: #112132;
  // --mcard-header-icon-w: 36px;
  // --mcard-header-icon-h: 36px;

  --header-height: var(--mcard-header-height);
  --header-font-size: var(--mcard-header-fs);
  --header-bg: var(--mcard-header-bg);
  --header-bar-bg: var(--mcard-header-bar-bg);
  --header-title-color: var(--mcard-header-title-color);
  --border: var(--mcard-border);
  --bg: var(--mcard-bg);
  --header-icon-w: var(--mcard-header-icon-w);
  --header-icon-h: var(--mcard-header-icon-h);

  width: 100%;
  height: 100%;

  box-sizing: border-box;

  border: var(--border);
  border-radius: 10px;

  overflow: hidden;

  background: var(--bg);

  &_header {
    position: relative;

    width: 100%;
    height: var(--header-height);

    &-icon {
      width: var(--header-icon-w);
      height: var(--header-icon-h);
    }

    &-content {
      height: var(--header-height);

      display: flex;
      align-items: center;
      gap: 10px;

      position: relative;
      z-index: 1;
      padding: 0 32px;

      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: var(--header-font-size);
      color: var(--header-title-color);
      line-height: 1;
      text-align: left;
      font-style: normal;
      text-transform: none;

      box-sizing: border-box;
    }

    &::before {
      content: ' ';
      border-top: var(--lt-mark-size) solid var(--lt-mark-color);
      border-right: var(--lt-mark-size) solid transparent;
      position: absolute;
      left: 5px;
      top: 5px;
      z-index: 2;
    }

    &-bg {
      width: calc(100% - 4px);
      height: calc(100% - 2px);
      position: absolute;
      left: 2px;
      top: 2px;

      pointer-events: none;

      &::before {
        content: ' ';

        position: absolute;
        left: 0;
        top: 0;

        width: calc(100% - var(--rt-mark-width) + var(--rt-mark-bar));
        height: 100%;

        background: var(--header-bg);
      }

      .pos-right {
        position: absolute;
        right: 0;
        top: 0;

        width: var(--rt-mark-width);
        height: 100%;
        display: flex;
        gap: var(--rt-mark-gap);

        .parallelogram {
          display: inline-block;
          width: var(--rt-mark-bar);
          height: 100%;
          background: var(--header-bar-bg);
          transform: skew(-20deg);

          &:first-of-type {
            width: calc(var(--rt-mark-bar) * 2.5);
            margin-right: calc(var(--rt-mark-gap) / 2.5);
          }
        }
      }
    }
  }

  &_content {
    height: calc(100% - var(--header-height));

    overflow: auto;

    @include scrollar-style-thin;
  }
}
</style>
